import React from 'react';
import { connect } from 'dva';
import type { Dispatch } from 'dva';

import styles from './index.css';
import VersionUploadForm from '../../../components/VersionUploadForm/index.js';
import type { UploadState } from '../../../models/upload.js';

const sections = [
  ['teacher2', '上传教师端安装包'],
  ['student2', '上传学生端安装包'],
  ['teacherUpdate2', '上传教师端更新文件'],
  ['serverUpdate2', '上传服务端更新文件'],
  ['studentUpdate2', '上传学生端更新文件'],
] as const;

interface UploadPageProps {
  readonly upload: UploadState;
  readonly dispatch: Dispatch;
}

function UploadPage({ upload, dispatch }: UploadPageProps): React.ReactElement {
  const versionData = upload.versionData ?? {};
  const dataValues = upload.dataValues ?? {};
  return (
    <div style={{ padding: '20px 20px' }}>
      {sections.map(([mode, title]) => (
        <div key={mode} style={{ margin: '20px 10px' }}>
          <div className={styles['title']}>{title}</div>
          <VersionUploadForm
            mode={mode}
            namespace="upload"
            appVersion="pclab2"
            versionData={versionData}
            dataValues={dataValues}
            validExtensions={['exe', 'msi']}
            accept="exe"
            changelogLabel="版本更新日志"
            uploadHint={
              <>
                Support for a single or bulk upload. Strictly prohibit from uploading company data
                or other band files
              </>
            }
            dispatch={dispatch}
          />
        </div>
      ))}
    </div>
  );
}

const ConnectedUploadPage: React.ComponentType = connect((state: { upload: UploadState }) => ({
  upload: state.upload,
}))(UploadPage);
export default ConnectedUploadPage;
